export const buttons = {
  seven: "7",
  eight: "8",
  nine: "9",
  del: "DEL",

  four: "4",
  five: "5",
  six: "6",
  add: "+",

  one: "1",
  two: "2",
  three: "3",
  subtract: "-",

  decimal: ".",
  zero: "0",
  multiply: "*",
  divide: "/",
};

export const resetAndEqual = {
  clear: "RESET",
  equals: "=",
};
